import { render } from "./office-results-card.vue?vue&type=template&id=62134d81"
import script from "./office-results-card.vue?vue&type=script&lang=js"
export * from "./office-results-card.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ars62917/Dropbox/voteomatic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__